import "./Users.css";
import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import axios from "axios";
// Components
import StandardPageWrapper from "../../components/StandardPageWrapper/StandardPageWrapper";
import StandardOutlinedTextfield from "../../components/StandardOutlinedTextfield/StandardOutlinedTextfield";
import ReactCustomTable from "../../components/ReactCustomTable/ReactCustomTable";
import CustomMuiSelect from "../../components/CustomMuiSelect/CustomMuiSelect";

function Users() {
  const { enqueueSnackbar } = useSnackbar();

  const [allUserData, setAllUserData] = useState([]);
  const [allUserDataLoading, setAllUserDataLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [addUserData, setAddUserData] = useState({
    first_name: "",
    phone_no: "",
    role: "",
    classid: "",
    schoolid: "",
  });
  const [allBtnData, setAllBtnData] = useState({ school: "", class: "" });
  const [allSchoolData, setAllSchoolData] = useState([]);
  const [allCLassData, setAllCLassData] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [deleteID, setDeleteID] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [allSchoolDataLoading, setAllSchoolDataLoading] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  useEffect(() => {
    fetchAllUsers();
  }, [page, limit, searchInput]);

  const fetchAllUsers = async () => {
    setAllUserDataLoading(true);
    await axios
      .get(`${process.env.REACT_APP_BASE_URL}/user/all-user`, {
        params: { page, limit, search: searchInput }
      })
      .then((res) => {
        if (res.data.success) {
          setAllUserData(res.data.data);
          setTotalCount(res.data.totalCount || 0);
        } else {
          enqueueSnackbar("Error Fetching Users, Try Again !!!", {
            variant: "error",
          });
        }
        setAllUserDataLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAllUserDataLoading(false);
        return enqueueSnackbar("Something Went Wrong !!!", {
          variant: "error",
        });
      });
  };

  const fetchAllSchools = async () => {
    await axios
      .get(`${process.env.REACT_APP_BASE_URL}/user/getallschool`)
      .then((res) => {
        if (res.data.success) {
          setAllSchoolData(res.data.data);
        } else {
          enqueueSnackbar("Error Fetching Schools, Try Again !!!", {
            variant: "error",
          });
        }
        setAllSchoolDataLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAllSchoolDataLoading(false);
        return enqueueSnackbar("Something Went Wrong !!!", {
          variant: "error",
        });
      });
  };

  const fetchAllClass = async (e) => {
    setAllBtnData({ ...allBtnData, school: e.target.value, class: "" });

    await axios
      .post(`${process.env.REACT_APP_BASE_URL}/user/getclassesbyschoolid`, {
        schoolid: e.target.value,
      })
      .then((res) => {
        if (res.data.success) {
          setAllCLassData(res.data.data);
        } else {
          enqueueSnackbar("Error Fetching Class, Try Again !!!", {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        return enqueueSnackbar("Something Went Wrong !!!", {
          variant: "error",
        });
      });
  };

  const onAddUser = async () => {
    if (Object.values(addUserData)?.includes(""))
      return enqueueSnackbar("Please Fill All The Details !!!", {
        variant: "error",
      });

    const body = { ...addUserData, is_verified: 1 };
    await axios
      .post(`${process.env.REACT_APP_BASE_URL}/user/signup`, body)
      .then((res) => {
        if (res.data.success) {
          setAllUserData([...allUserData, res.data.data[0]]);
          enqueueSnackbar("User Added Successfully !!!", {
            variant: "success",
          });
        } else {
          enqueueSnackbar(res.data.message, { variant: "error" });
        }
        setOpenDialog(false);
        setAddUserData({
          first_name: "",
          phone_no: "",
          role: "",
          classid: "",
          schoolid: "",
        });
      })
      .catch((err) => {
        console.log(err);
        return enqueueSnackbar("Something Went Wrong !!!", {
          variant: "error",
        });
      });
  };

  const onDeletePrompt = (e, data) => {
    e.stopPropagation();
    setSelectedUser(data);
    setDeleteDialogOpen(true);
  };

  const confirmDeleteUser = async () => {
    if (!selectedUser) return;
    setDeleteID(selectedUser.id);
    setDeleteLoading(true);

    await axios
      .post(`${process.env.REACT_APP_BASE_URL}/user/deleteuserwithrecords`, {
        user_id: selectedUser.id,
      })
      .then((res) => {
        if (res.data.success) {
          setAllUserData(
            allUserData?.filter((user) => user?.id !== selectedUser?.id)
          );
          enqueueSnackbar("User Deleted Successfully !!!", {
            variant: "success",
          });
        } else {
          enqueueSnackbar("Error Deleting User, Try Again !!!", {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar("Something Went Wrong !!!", {
          variant: "error",
        });
      })
      .finally(() => {
        setDeleteID("");
        setDeleteLoading(false);
        setDeleteDialogOpen(false);
        setSelectedUser(null);
      });
  };

  const tableActions = [
    {
      icon: <Delete sx={{ cursor: "pointer" }} color="error" />,
      onClick: onDeletePrompt,
      btnType: "delete",
    },
  ];

  const filterIdCards = (data) => {
    return data.filter((card) => {
      const searchString =
        `${card.id} ${card.first_name} ${card.classid} ${card.schoolid} ${card.phone_no}`.toLowerCase();
      return searchString.includes(searchInput.toLowerCase());
    });
  };

  return (
    <StandardPageWrapper
      header="Users"
      btns={
        <>
          <Button
            variant="contained"
            component="label"
            onClick={() => {
              setOpenDialog(true);
              fetchAllSchools();
            }}
          >
            Add User
          </Button>
        </>
      }
    >
      <TextField
        sx={{ marginRight: "30px", marginLeft: "10px" }}
        variant="outlined"
        type="text"
        fullWidth
        placeholder="Search Users..."
        value={searchInput}
        onChange={(e) => {
          setSearchInput(e.target.value);
          setPage(1);
        }}
      />
      <div id="users">
        <ReactCustomTable
          data={allUserData}
          tableColumns={tableColumns}
          loading={allUserDataLoading}
          onRowClick={() => { }}
          tableActions={tableActions}
          actionsColumnWidth={90}
          deleteID={deleteID}
          deleteLoading={deleteLoading}
          rowDataDeleteKey="id"
          circularColor="#d32f2f"
          // Pagination props
          total={totalCount}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={(l) => { setLimit(l); setPage(1); }}
        />
      </div>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        className="users_addDialog"
      >
        <DialogTitle className="users_addDialog_title">Add Users</DialogTitle>
        <DialogContent>
          <StandardOutlinedTextfield
            label="First Name"
            name="first_name"
            val={addUserData.first_name}
            setVal={setAddUserData}
            spreadData={addUserData}
          />
          <StandardOutlinedTextfield
            label="Phone Number"
            name="phone_no"
            type="number"
            val={addUserData.phone_no}
            setVal={setAddUserData}
            spreadData={addUserData}
          />
          {/* <StandardOutlinedTextfield
            label="Class ID"
            name="classid"
            val={addUserData.classid}
            setVal={setAddUserData}
            spreadData={addUserData}
            type="number"
          /> */}

          <TextField
            fullWidth
            select
            label="School"
            value={addUserData.schoolid}
            onChange={(e) => {
              setAddUserData({ ...addUserData, schoolid: e.target.value });
              fetchAllClass(e);
            }}
            sx={{ marginTop: 1.5 }}
          >
            {/* <MenuItem value='admin'>Admin</MenuItem>
                        <MenuItem value='principal'>Principal</MenuItem> */}
            {allSchoolData?.map((c, i) => (
              <MenuItem value={c?.schoolid} key={i}>
                {c?.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            fullWidth
            select
            label="Class"
            value={addUserData.classid}
            onChange={(e) =>
              setAddUserData({ ...addUserData, classid: e.target.value })
            }
            sx={{ marginTop: 1.5 }}
          >
            {/* <MenuItem value='admin'>Admin</MenuItem>
                        <MenuItem value='principal'>Principal</MenuItem> */}
            {allCLassData?.map((c, i) => (
              <MenuItem value={c?.classid} key={i}>
                {c?.division}
              </MenuItem>
            ))}
          </TextField>

          {/* <CustomMuiSelect label='Select School' val={allBtnData.school} onChange={fetchAllClass} width={150} size='small' disabled={searchLoading} >
                    {allSchoolData?.map((c, i) => <MenuItem value={c?.schoolid} key={i} >{c?.name}</MenuItem>)}
                </CustomMuiSelect> */}

          {/* <CustomMuiSelect label='Select Class' val={allBtnData.class} onChange={(e) => setAllBtnData({ ...allBtnData, class: e.target.value })} width={150} size='small' sx={{ marginRight: 1.5 }} disabled={searchLoading} >
                    {allCLassData?.map((c, i) => <MenuItem value={c?.classid} key={i} >{c?.division}</MenuItem>)}
                </CustomMuiSelect> */}

          {/* <StandardOutlinedTextfield
            label="School ID"
            name="schoolid"
            val={addUserData.schoolid}
            setVal={setAddUserData}
            spreadData={addUserData}
            type="number"
          /> */}
          {/* <StandardOutlinedTextfield label="Last Name" name='last_name' val={addUserData.last_name} setVal={setAddUserData} spreadData={addUserData} /> */}
          {/* <StandardOutlinedTextfield label="Email" name='email' type='email' val={addUserData.email} setVal={setAddUserData} spreadData={addUserData} />
                    <StandardOutlinedTextfield label="Password" name='password' val={addUserData.password} setVal={setAddUserData} spreadData={addUserData} /> */}

          <TextField
            fullWidth
            select
            label="Role"
            value={addUserData.role}
            onChange={(e) =>
              setAddUserData({ ...addUserData, role: e.target.value })
            }
            sx={{ marginTop: 1.5 }}
          >
            {/* <MenuItem value='admin'>Admin</MenuItem>
                        <MenuItem value='principal'>Principal</MenuItem> */}
            <MenuItem value="student">Student</MenuItem>

            <MenuItem value="teacher">Teacher</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            onClick={() => setOpenDialog(false)}
            sx={{ fontWeight: 600, letterSpacing: 1 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={onAddUser}
            sx={{ fontWeight: 600, letterSpacing: 1 }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteDialogOpen}
        onClose={() => {
          if (deleteLoading) return;
          setDeleteDialogOpen(false);
          setSelectedUser(null);
        }}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Delete User</DialogTitle>
        <DialogContent dividers>
          {selectedUser ? (
            <>
              Are you sure you want to delete{" "}
              <strong>{selectedUser.first_name}</strong>? This action cannot be
              undone.
            </>
          ) : (
            "No user selected."
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (deleteLoading) return;
              setDeleteDialogOpen(false);
              setSelectedUser(null);
            }}
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button
            color="error"
            onClick={confirmDeleteUser}
            disabled={deleteLoading}
            sx={{ fontWeight: 600 }}
          >
            {deleteLoading ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </StandardPageWrapper>
  );
}

export default Users;

const tableColumns = [
  {
    label: "ID",
    key: "id",
    width: 100,
    fixed: true,
  },
  {
    label: "Name",
    key: "first_name",
    minWidth: 170,
    flexGrow: 1,
    fixed: false,
    fullText: true,
  },
  // {
  //     label: 'Last Name',
  //     key: 'last_name',
  //     minWidth: 170,
  //     flexGrow: 1,
  //     fixed: false,
  //     fullText: true
  // },
  // {
  //     label: 'Email',
  //     key: 'email',
  //     width: 450,
  //     fixed: false,
  //     fullText: true
  // },
  {
    label: "Phone Number",
    key: "phone_no",
    width: 120,
    fixed: false,
  },
  {
    label: "Role",
    key: "role",
    width: 100,
    fixed: false,
  },
  {
    label: "School ID",
    key: "schoolid",
    width: 75,
    fixed: false,
  },
  {
    label: "Class ID",
    key: "classid",
    width: 65,
    fixed: false,
    align: "center",
  },
];
